import React from 'react';
import * as Yup from "yup";
import NotificationSettingForm from './NotificationSettingForm'
import { Paper, withStyles } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "./store/notificationSettingActions";
import History from "../../../History";
import { getFormattedPossibleNotifications } from './utils';

const styles = theme => ({
    root: {
        width: `99.1%`,
        height: 'auto',
        margin: '7px',
        marginBottom: 0,
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const NotificationSettingCreate = props => {
    const { loading, classes, activeCustomer, translations, permissions, customers } = props;

    const possibleNotifications = getFormattedPossibleNotifications(translations);
    const extractType = selectedType => {
        return selectedType.map(type => type.value);
    }

    const handleSubmit = async data => {
        let objToSend = { ...data }
        objToSend['Type'] = extractType(data.Type)
        objToSend['CustomerID'] = data['CustomerID'] === '' ? null : data['CustomerID'];
        let result = await props.onCreateNotificationSetting({ ...objToSend, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack()
        }
    }

    const cancelHandler = () => {
        History.goBack();
    };

    let initialValues = {
        Receivers: "",
        Type: [],
        CustomerID: ''
    };

    let formSettings = {
        Validation: {
            Receivers: Yup.string().required("Required"),
            Type: Yup.array().required("Required")
        },
        FormTitle: translations['create_notification_setting'] || 'Create notification setting',
        ButtonSubmit: hasPermission(permissions, "notification_setting_create")
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null,
        ButtonCancel: {
            Title: translations["cancel"] || "Cancel",
            handleCancel: cancelHandler
        }
    };

    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <NotificationSettingForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                customers={customers}
                loading={loading}
                possibleNotifications={possibleNotifications}
                translations={translations}
            />
        </Paper>)
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        customers: state.core.login.customers,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        loading: state.setting.notificationSettings.creating
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateNotificationSetting: notificationSetting => dispatch(actions.createNotificationSetting(notificationSetting)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(NotificationSettingCreate));
